/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import {UserVO} from '@/valueObjects/UserVO'
import {Getter} from 'vuex-class'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import AnalysisDropdown from '@/components/analysis/AnalysisDropdown'
import {UserService} from '@/services/UserService'
import UserServiceMixin from '@/services/UserServiceMixin'

@Component({
    mixins: [UserServiceMixin],
    components: {
        AnalysisDropdown,
    },
})

export default class NavBar extends Vue {

    private userService: UserService
    private quota: any = ""

    @Getter('getCurrentUser') private currentUser: UserVO

    @Prop()
    private analysis: AnalysisVO

    @Prop()
    private isFinished: boolean

    @Getter('getIsLoading') private isLoading: boolean

    public created(): void {
        if (this.currentUser === null) {
            this.$router.push({path: '/'})
        }
        this.get_quota()
    }

    private onException(message: string) {
        // transmit the event from our son to our father
        this.$emit('exception', message)

    }

    private async get_quota(){
        let quota: any =""
        if (this.currentUser.isAdmin()){
            quota= "No request limitation"
        }else{
            quota = await this.userService.getquota(this.currentUser.id)
            quota = quota.data
        }
        //console.log(quota)
        this.quota = quota
    }

    private get_nb_stat(): string{
        return "5"
    }

    private get_nb_dyn(): string{
        return "5"
    }
}
